import { useScaffold } from "@Light/scaffold";

export function ErrorPage() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <ErrorMessage />
    </div>
  );
}

export function ErrorMessage() {
  const scaffold = useScaffold();
  const Hyperlink = scaffold.page.hyperlink;
  return (
    <div className="p-12 m-8 text-center rounded-lg shadow-lg bg-white">
      <h1 className="mb-4 text-2xl font-bold">Sorry, something went wrong</h1>
      <p className="text-md text-gray-600">
        Please reach out to{" "}
        <Hyperlink
          href={`mailto:${scaffold.page.supportEmail}`}
          className="text-blue-600 underline"
        >
          {scaffold.page.supportEmail}
        </Hyperlink>{" "}
        if you continue to experience this issue.
      </p>
    </div>
  );
}
